import MediaFormPage from "./MediaFormPage"

const MediaCreate = () => {
  return (
    <MediaFormPage></MediaFormPage>
  )
}

export default MediaCreate